import { CALCULATOR_RESULT_CARD } from 'components/Widget/shared/cardStyles';
import { CalculatorEnrollmentCta } from 'components/Widget/shared/CalculatorEnrollmentCta';
import { formatCurrency, fromCents } from 'components/Widget/shared/currency';
import { HeroAmount } from 'components/Widget/shared/HeroAmount';
import { cn } from 'utils/styles';
import { frequencyPhrase, RESULT_COPY, RESULT_ROWS, SEGMENT_COLORS } from './constants';
import { PaycheckDonutGraph } from './PaycheckDonutGraph';
import type { PaycheckPanel } from './types';

interface PaycheckCalculatorResultProps {
  panel: PaycheckPanel;
}

const LABEL = 'text-label-serif text-content-secondary';

export const PaycheckCalculatorResult = ({ panel }: PaycheckCalculatorResultProps) => {
  const { result } = panel;
  const frequency = frequencyPhrase(panel.payFrequency);

  return (
    <div className={cn(CALCULATOR_RESULT_CARD, 'gap-5')}>
      {/* The table's take-home row reads this figure, and the live region announces it on Calculate. */}
      <div aria-hidden>
        <p className={LABEL}>{RESULT_COPY.eyebrow(frequency)}</p>
        <HeroAmount value={fromCents(result.takeHome)} />
      </div>

      <PaycheckDonutGraph result={result} />

      <table className="w-full border-collapse text-left">
        <tbody>
          {RESULT_ROWS.map(row => (
            <tr key={row.key} className="border-t border-border-primary first:border-t-0">
              <th scope="row" className={cn(LABEL, 'py-3 pr-3 font-normal')}>
                {/* Gross is the whole ring, and a zero line draws no segment, so neither has one to key. */}
                {row.key !== 'gross' && result[row.key] > 0 && (
                  <span
                    aria-hidden
                    className={cn(
                      'mr-2 inline-block size-3 rounded-full bg-current align-middle',
                      SEGMENT_COLORS[row.key],
                    )}
                  />
                )}
                {row.label(frequency)}
              </th>
              <td className="py-3 text-right text-heading-sm whitespace-nowrap">
                {formatCurrency(fromCents(result[row.key]))}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <CalculatorEnrollmentCta />
    </div>
  );
};
